import {ImmutableObject} from "../../../utils/immutableObject";
import {Corridor} from "../../corridor/corridor";
import {EnumCorridorColor} from "../../enum/enum-corridor-color";
import { ProductPricing } from "../../product/product-princing.model";
import { InitialArticleInfo } from "quote-domain-core";

export class Article extends ImmutableObject {

    constructor(public readonly codeElis?: string,
                public readonly label?: string,
                public readonly productPricings?: ProductPricing[],
                public readonly articleDetails?: Record<string, any>,
                public readonly corridor?: Corridor,
                public readonly lastCorridorState?: Corridor,
                public readonly appliedPrice?: string,
                public readonly appliedPriceColor?: EnumCorridorColor,
                public readonly lastAppliedPriceColor?: EnumCorridorColor,
                public readonly discount?: string,
                public readonly status?: string,
                public readonly distance?: string,
                public readonly groupingCode?: string,
                public readonly totalQuantity?: number,
                public readonly existsInProductDb: boolean = true,
                public readonly isRenewal: boolean = false,
                public readonly oldAppliedPrice?: string,
                public readonly oldDistance?: string,
                public readonly oldAppliedPriceColor?: EnumCorridorColor,
                public readonly isCmcWithStandardProductPricing: boolean=false,
                public readonly pcc?: string,
                public readonly pccType?: string,
                public readonly ppe?: boolean,
                public readonly catalogPrice?: string,
                public readonly logisticPrice?: string,
                public readonly greenPrice?: string,
                public readonly blackPrice?: string,
                public readonly grossMarginRate?: string,
                public readonly washRate?: string,
                public readonly washLifetime?: string,
                public readonly replacementPrice?: string,
                public readonly initialArticleInfo?: InitialArticleInfo
    ) {
        super();
    }
}
